import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppStore from '../../stores/app-store';
import AppActions from '../../actions/app-actions';

import Configs from './config-system';
import Flavors from './config-flavor';
import { AppContext } from '../../contexts/app-context';

const routes = {
  configs: {
    route: '/configurations/config-system',
    status: 'config-system',
    title: 'Configs'
  },
  flavors: {
    route: '/configurations/config-flavor',
    status: 'config-flavor',
    title: 'Flavors'
  }
};

export default class Configurations extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();
    /** Bind methods to avoid method re-creation */
    this._onChangeBind = this._onChange.bind(this);    
  }

  _getInitialState() {
    return {
      tabIndex: this._updateActive(),
      snackbar: AppStore.getSnackbar(),
      hasMultitenancy: AppStore.hasMultitenancy()
    };
  }

  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChangeBind);
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this._onChangeBind);
  }

  componentDidMount() {}

  UNSAFE_componentWillReceiveProps() {
    this.setState({ tabIndex: this._updateActive() });
  }

  _onChange() {
    // this.setState(this._getInitialState());
  }

  _updateActive(tab = this.context.router.route.match.params.tab) {
    if (routes.hasOwnProperty(tab)) {
      return routes[tab].route;
    }
    return routes.configs.route;
  }

  _handleTabActive(tab) {
    var self = this;
    self.context.router.history.push(tab.props.value);
  }
  _changeTab(route) {
    var self = this;
    AppActions.setSnackbar('');
    self.context.router.history.push(route);
  }

  render() {

    const tabIndex = this.context.router.route.match.params.tab || 'config-system';
    return (
      <div style={{ marginTop: '-15px' }}>
        <Tabs value={tabIndex} onChange={() => this._changeTab.bind(this)}>
          <Tab component={Link} label={routes.flavors.title} value={routes.flavors.status} to={routes.flavors.route} />
          <Tab component={Link} label={routes.configs.title} value={routes.configs.status} to={routes.configs.route} />
        </Tabs>
        <AppContext.Consumer>
          {({ globalSettings, docsVersion }) => (
            <div>
              {tabIndex === routes.configs.status && (
                <Configs 
                  docsVersion={docsVersion}
                  globalSettings={globalSettings}
                />
              )}
              {tabIndex === routes.flavors.status && (
                <Flavors />
              )}
            </div>
          )}
        </AppContext.Consumer>
      </div>
    )
  }
}
